export const AIAvatar = () => (
  <div
    data-testid="ai-avatar"
    className="w-[30px] h-[30px] rounded-full bg-brand flex items-center justify-center flex-shrink-0"
  >
    <p className="font-inter text-xs-500 text-brand-foreground">AI</p>
  </div>
)
